/*
 * Safari and Firefox don't draw see-through blurs (backdrop-filter) inside
 * page transition animations (e.g. a release cover gliding back to the home
 * page), so the Releases panel would show the sharp photo until the
 * animation ends.
 *
 * This marks the page so CSS can cover for it:
 * - <html class="is-view-transition"> while a page transition is running
 * - --releases-top: where the Releases panel starts on screen during it
 * Releases.css then shows a pre-blurred copy of the photo just for that time.
 * (In every browser: where the real blur does work, e.g. Chrome, the stand-in
 * looks the same, so there's no need to guess which browser this is.)
 */
export function setUpViewTransitionFlag() {
  const root = document.documentElement;
  if (typeof document.startViewTransition !== "function") return;

  const start = document.startViewTransition.bind(document);
  document.startViewTransition = (...args) => {
    root.classList.add("is-view-transition");
    const transition = start(...args);
    const place = () => {
      const panel = document.querySelector(".releases");
      if (panel) root.style.setProperty("--releases-top", `${panel.getBoundingClientRect().top}px`);
    };
    place();
    // After the new page is in place, before its snapshot is taken
    transition.updateCallbackDone?.then(place, () => {});
    transition.finished
      .catch(() => {})
      .finally(() => root.classList.remove("is-view-transition"));
    return transition;
  };
}
